import { QC_TASK_REPORT_TABS } from '../constants/qcTaskReportConstants';

/**
 * @param {string} tab - `APPROVED` | `REJECTED`
 * @returns {'APPROVED' | 'REJECTED'}
 */
export function reqStatusFromReportTab(tab) {
  if (tab === QC_TASK_REPORT_TABS.REJECTED) return 'REJECTED';
  return 'APPROVED';
}
